import { Typography } from '@mui/material'

//components
import { UnlockGmailRewardsButton } from '../GmailConnection/UnlockGmailRewardsButton'
//styles
import './index.css'
//types
import { GenericUnlockGmailRewardsTaskProps } from 'types'

const GenericUnlockGmailRewardsTask = ({ customClassName }: GenericUnlockGmailRewardsTaskProps) => {
  return (
    <div className="gameDetailsOfferParentContainer">
      <div className={`gameDetailsOffer ${customClassName} `}>
        <div className={`container locked`}>
          <div className="lock-container">
            <img src={`/images/lock.png`} />
          </div>
          <div className="content">
            <Typography variant="body2" className="sub-title" sx={styles.text}>
              Earn <img src="/images/coin.png" style={styles.coinIcon} /> for every non-offer game
              purchase.
            </Typography>

            <Typography variant="body2" className="sub-title" sx={styles.text}>
              The base rate is <strong>$1 USD</strong> ={' '}
              <div className="valueGradientWrap earnGiftCardsValueLocked">
                <Typography variant="body2" className="priceText">
                  <strong>100</strong> <img src="/images/coin.png" style={styles.coinIcon} />
                </Typography>
              </div>
            </Typography>
          </div>
        </div>
        <UnlockGmailRewardsButton buttonText="Unlock Rewards" />
      </div>
    </div>
  )
}

const styles = {
  text: {
    fontSize: {
      sm: '16px',
      xs: '14px',
    },
  },
  coinIcon: {
    width: '18px',
    height: '18px',
  },
}

export default GenericUnlockGmailRewardsTask
